/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Footer_AllInputs */

const en_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People you invite get 300 coins.`)
};

const ar_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يحصل الأشخاص الذين تدعوهم على 300 عملة.`)
};

const de_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von dir eingeladene Personen erhalten 300 Münzen.`)
};

const es_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las personas que invites reciben 300 monedas.`)
};

const fr_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les personnes que vous invitez reçoivent 300 pièces.`)
};

const it_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le persone che inviti ricevono 300 monete.`)
};

const ja_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待した人は300コインを獲得できます。`)
};

const ko_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대한 사람은 코인 300개를 받아요.`)
};

const pt_br_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As pessoas que você convidar ganham 300 moedas.`)
};

const ru_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приглашенные вами люди получают 300 монет.`)
};

const th_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คนที่คุณเชิญจะได้รับ 300 เหรียญ`)
};

const tr_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet ettiğin kişiler 300 jeton alır.`)
};

const zh_cn_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你邀请的人可获得 300 金币。`)
};

const zh_tw_invite_footer_all = /** @type {(inputs: Invite_Footer_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你邀請的人可獲得 300 金幣。`)
};

/**
* | output |
* | --- |
* | "People you invite get 300 coins." |
*
* @param {Invite_Footer_AllInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_footer_all = /** @type {((inputs?: Invite_Footer_AllInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Footer_AllInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_footer_all(inputs)
	if (locale === "ar") return ar_invite_footer_all(inputs)
	if (locale === "de") return de_invite_footer_all(inputs)
	if (locale === "es") return es_invite_footer_all(inputs)
	if (locale === "fr") return fr_invite_footer_all(inputs)
	if (locale === "it") return it_invite_footer_all(inputs)
	if (locale === "ja") return ja_invite_footer_all(inputs)
	if (locale === "ko") return ko_invite_footer_all(inputs)
	if (locale === "pt_br") return pt_br_invite_footer_all(inputs)
	if (locale === "ru") return ru_invite_footer_all(inputs)
	if (locale === "th") return th_invite_footer_all(inputs)
	if (locale === "tr") return tr_invite_footer_all(inputs)
	if (locale === "zh_cn") return zh_cn_invite_footer_all(inputs)
	return zh_tw_invite_footer_all(inputs)
});